import styled from 'styled-components';

export default styled.div`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  user-select: none;
  display: grid;
  grid-auto-flow: row;
  grid-column-gap: 0.5rem;
  grid-row-gap: 0.5rem;
`;
